import { render, staticRenderFns } from "./bannerVant.vue?vue&type=template&id=0be6f34a&scoped=true&"
import script from "./bannerVant.vue?vue&type=script&lang=js&"
export * from "./bannerVant.vue?vue&type=script&lang=js&"
import style0 from "./bannerVant.vue?vue&type=style&index=0&id=0be6f34a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be6f34a",
  null
  
)

export default component.exports